import React from "react";
import { formatMoedaSimples, formatMoedaAmbas, formatMoney } from "../utils/formatMoney";

/**
 * Rodapé com o totalizador geral do relatório.
 * 
 * @param {Object} props
 * @param {string} props.tipo - "soa" (contas a receber) ou "liquidado" (pagas/recebidas) ou "contasPagar"
 * @param {Object} props.totais - Objeto com os totais a exibir
 * @param {number} props.moeda - Moeda selecionada (5=BRL, 6=USD)
 * @param {boolean} props.mostrarAmbasMoedas - Se true, exibe BRL e USD
 */
export default function TotalGeral({ tipo, totais, moeda = 5, mostrarAmbasMoedas = false }) {
  const isEnglish = parseInt(moeda) !== 5 || mostrarAmbasMoedas;
  
  const formatarValor = (valor, valorUsd) => {
    if (mostrarAmbasMoedas && valorUsd !== undefined) {
      return formatMoedaAmbas(valor, valorUsd);
    }
    return formatMoedaSimples(valor || 0, moeda);
  };

  // Mostra variação apenas se o relatório for do tipo liquidado e NÃO for exclusivamente em dólares
  const mostrarVariacao = tipo === "liquidado" && !(parseInt(moeda) === 6 && !mostrarAmbasMoedas);

  return (
    <div className="total-geral">
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th></th>
            <th style={{ borderBottom: "1px solid black" }} className="texto-direita">{isEnglish ? "ORIGINAL AMOUNT" : "VALOR ORIGINAL"}</th>
            {mostrarVariacao && <th style={{ borderBottom: "1px solid black" }} className="texto-direita">{isEnglish ? "EXC. VAR." : "VAR. CAMBIAL"}</th>}
            <th style={{ borderBottom: "1px solid black" }} className="texto-direita">{isEnglish ? "PAID" : "PAGO"}</th>
            {tipo !== "liquidado" && <th style={{ borderBottom: "1px solid black" }} className="texto-direita">{isEnglish ? "BALANCE" : "SALDO"}</th>}
          </tr>
        </thead>
        <tbody>
          <tr style={{ fontWeight: "bold" }}>
            <td style={{ textAlign: "left" }}>{isEnglish ? "GRAND TOTAL:" : "TOTAL GERAL:"}</td>
            <td className="texto-direita">
              {formatarValor(totais?.bruto, totais?.brutoUsd)}
            </td>
            {mostrarVariacao && <td className="texto-direita" style={{ color: totais?.variacao_cambial < 0 ? "red" : (totais?.variacao_cambial > 0 ? "green" : "inherit") }}>
              {formatarValor(totais?.variacao_cambial, totais?.variacao_cambialUsd)}
            </td>}
            <td className="texto-direita">
              {formatarValor(totais?.pago, totais?.pagoUsd)}
            </td>
            {tipo !== "liquidado" && <td className="texto-direita">
              {formatarValor(totais?.saldo, totais?.saldoUsd)}
            </td>}
          </tr>
        </tbody>
      </table>
    </div>
  );
}